import config from '../../config';
import { BUNDLE_STEP, LIVE_SUPPORT_STEP } from './upsell-flow-steps';

const URLS = {
    [LIVE_SUPPORT_STEP]: () => '/upsell/special/v3',
    [BUNDLE_STEP]: () => '/upsell/bundle'
};

const FLOWS = {
    v16: {
        steps: () => [
            { id: BUNDLE_STEP, withSuccessModal: true },
            { id: LIVE_SUPPORT_STEP }
        ]
    },
    v19: {
        steps: () => [
            { id: BUNDLE_STEP, withSuccessModal: true },
            { id: LIVE_SUPPORT_STEP }
        ]
    },
    v28: {
        steps: () => [
            { id: BUNDLE_STEP, withSuccessModal: true },
            { id: LIVE_SUPPORT_STEP }
        ]
    }
};

const thankYouUrl = subscriptionId => `${config.platformUrl}/subscription/${subscriptionId}/thank-you?is_upsell=true`;
const dashboardUrl = () => `${config.platformUrl}/dashboard`;

const stepUrl = (step, prelander, subscriptionId) =>
    `${URLS[step.id](prelander)}?subscriptionId=${subscriptionId}`;

const getNextUrl = ({ next, prelander, subscriptionId }) => {
    if (!subscriptionId) return dashboardUrl();

    return next ? stepUrl(next, prelander, subscriptionId) : thankYouUrl(subscriptionId);
};

const resolveStep = ({ prelander, id, subscriptionId, conditions = {} }) => {
    const steps = FLOWS[prelander]?.steps(conditions) ?? [];
    const idx = steps.findIndex(s => s.id === id);
    const current = steps[idx];
    const next = idx === -1 ? undefined : steps[idx + 1];

    return {
        ui: current?.ui ?? {},
        withSuccessModal: current?.withSuccessModal === true,
        nextUrl: getNextUrl({ next, prelander, subscriptionId })
    };
};

const resolveFirstStepUrl = (prelander, subscriptionId, conditions = {}) => {
    const [first] = FLOWS[prelander]?.steps(conditions) ?? [];

    return getNextUrl({ next: first, prelander, subscriptionId });
};

export {
    resolveStep,
    resolveFirstStepUrl
};
